var _style, _path, _path2, _path3, _ellipse, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.32,463.56c-18.76,24.82-18.76,65.22,0,90.28c18.76,24.82,49.29,24.82,68.24,0c129.86-171.8,341.2-171.8,471.06,0 c9.38,12.41,21.7,18.74,34.03,18.74s24.65-6.33,34.03-18.74c18.76-24.82,18.76-65.22,0-90.28 C636.3,241.88,363.7,241.88,196.32,463.56L196.32,463.56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326.55,635.85c-18.76,24.82-18.76,65.22,0,90.28c18.76,24.82,49.29,24.82,68.24,0c57.94-76.9,152.48-76.9,210.42,0 c9.38,12.41,21.7,18.74,34.03,18.74s24.65-6.33,34.03-18.74c18.76-24.82,18.76-65.22,0-90.04 C577.81,509.31,422.2,509.31,326.55,635.85L326.55,635.85z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 865.07,
    rx: 64.19,
    ry: 84.93
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M935.93,288.35c-240.41-317.8-631.45-317.8-871.86,0c-18.76,24.82-18.76,65.22,0,90.28c18.76,24.82,49.29,24.82,68.24,0 c202.7-268.41,532.68-268.41,735.56,0c9.38,12.41,21.7,18.74,34.03,18.74s24.65-6.33,34.03-18.74 C954.69,353.81,954.69,313.41,935.93,288.35L935.93,288.35z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.770cba1506ade231e418335584fd132f.svg";
export { ForwardRef as ReactComponent };